import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="job-form-step4"
export default class extends Controller {
  static targets = ["navItem", "section"]
  declare readonly navItemTargets: HTMLElement[]
  declare readonly sectionTargets: HTMLElement[]

  connect(): void {
    // console.log('connect')
    // console.log(this.navItemTargets)
    this.initScroll()
  }

  initScroll(): void {
    window.scrollTo({ top: 0, behavior: 'instant' });

    // スクロールイベントのリスナーを設定
    window.addEventListener('scroll', this.handleScroll.bind(this))

    // 初期状態で一度実行
    this.handleScroll()

    // ナビゲーションリンクのクリックイベントを設定
    this.navItemTargets.forEach(item => {
      const link = item.querySelector('a')
      if (link) {
        link.addEventListener('click', this.handleNavClick.bind(this))
      }
    })
  }

  handleScroll(): void {
    const companyInfoSection = document.getElementById('company_info')
    const companyInfoItem = this.navItemTargets.find(item =>
      item.querySelector('a')?.getAttribute('href') === '#company_info'
    )

    // 全ての.nav_itemのis_activeを一旦リセット
    this.navItemTargets.forEach(item => {
      item.classList.remove('is_active')
    })

    // 各セクションの位置を取得し、現在のスクロール位置に基づいて現在のセクションを特定
    let currentSection: HTMLElement | undefined
    this.sectionTargets.forEach(section => {
      const sectionTop = section.offsetTop
      const sectionHeight = section.offsetHeight
      if (window.scrollY >= sectionTop - 100 && window.scrollY < sectionTop + sectionHeight) {
        currentSection = section
      }
    })

    // id="company_info"よりも下にスクロールしている場合は「企業情報」をアクティブに
    if (companyInfoSection && companyInfoItem &&
        window.scrollY >= companyInfoSection.offsetTop - 100) {
      companyInfoItem.classList.add('is_active')
      return
    }

    // 対応するセクションがある場合、その.nav_itemに`is_active`を付与
    if (currentSection) {
      this.navItemTargets.forEach(item => {
        const targetId = item.querySelector('a')?.getAttribute('href')?.replace('#', '')
        if (currentSection?.id === targetId) {
          item.classList.add('is_active')
        }
      })
    }
  }

  handleNavClick(event: Event): void {
    event.preventDefault()
    const link = event.currentTarget as HTMLAnchorElement
    const targetId = link.getAttribute('href')?.replace('#', '')
    const targetElement = document.getElementById(targetId || '')

    if (targetElement) {
      // 一時的に CSS のスムーススクロールを無効化
      document.documentElement.style.scrollBehavior = 'auto'

      // 通常スクロールで移動
      window.scrollTo({
        top: targetElement.offsetTop - 47, // 47px（固定ボタンの高さ）のオフセット考慮
        behavior: 'auto' // スムーススクロール無効
      })

      // 次のフレームで CSS のスムーススクロールを元に戻す
      requestAnimationFrame(() => {
        document.documentElement.style.scrollBehavior = ''
      })
    }
  }
}
